import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-title px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_back_icon = _resolveComponent("base-back-icon")!
  const _component_layouts_guest = _resolveComponent("layouts-guest")!

  return (_openBlock(), _createBlock(_component_layouts_guest, null, {
    default: _withCtx(() => [
      _createVNode(_component_base_back_icon),
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.t('not_found.title')), 1)
    ]),
    _: 1
  }))
}